import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  text: {
    fontWeight: 400,
    fontSize: 11,
    color: colors.neutral900,
  },

  bottomContainer: {
    width: '100%',
    minHeight: 80,
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    marginRight: 30,
  },

  cryptoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    maxWidth: '100%',
    backgroundColor: colors.neutral50,
    border: `1.2px dashed ${colors.neutral200}`,
    borderRadius: '2px',
    padding: '13px',
  },

  token: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '10px',
    alignItems: 'center',
    justifyContent: 'center',
  },

  title: {
    textTransform: 'uppercase',
    fontWeight: 700,
    lineHeight: '1px',
  },

  tokenImg: {
    height: '26px',
    width: '26px',
    marginRight: '5px',
  },

  tokenContainer: {
    display: 'flex',
    flexDirection: 'row',
  },

  tokenText: {
    textTransform: 'uppercase',
    fontWeight: 400,
    fontSize: 11,
    color: colors.neutral900,
    marginLeft: '5px',
  },

  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '2px',
  },
});
